import { FETCH_DOCTOR_APPOINTMENT_HISTORY } from "../actions/type";

const INITIAL_STATE = {
 
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_DOCTOR_APPOINTMENT_HISTORY:       
      return {
        ...state,
       doctorAppointmentHistory:payload
      };
    // case FETCH_SELECTED_APPOINTMENT_DETAILS:
    //   return {...state,selectedAppointment:payload};
    default:
      return state;
  }

};

